import { RequestService } from '../../../../../common/services/RequestService';
import { TACHOGRAPHS_GET } from '../../constants';

export const getTachographsRequest = payload => {
  return RequestService.get(TACHOGRAPHS_GET);
};
